import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {MatIconModule} from '@angular/material/icon';
import {ECasePipesModule} from '../core/pipes/pipes.module';
import {EmptyStateComponent} from './empty-state.component';

@NgModule({
  declarations: [EmptyStateComponent],
  imports: [CommonModule, MatIconModule, ECasePipesModule],
  exports: [EmptyStateComponent]
})
export class EmptyStateModule {
}
